import { Injectable, TemplateRef } from '@angular/core';
import {
  AccurateTimeDetails,
  Project,
  Label,
  ShiftColorOptions,
  TimelineShift,
} from '@wilson/interfaces';

export interface ShiftCardCellViewPreviewContext {
  shift: TimelineShift;
  isMinimalHeight: boolean;
  shiftColorOption: ShiftColorOptions;
  label: Label | null;
  project: Project | null;
  shiftCategoryId: string | null;
  hasProjectReadPermission: boolean;
  showShiftValidation: boolean;
  hasShiftBeenValidated: boolean;
  isLoadingValidations: boolean;
  isLoadingValidationsError: boolean;
  isShiftValid: boolean;
  isShiftCompleted: boolean;
  isShiftStarted: boolean;
  shiftStartDetail: AccurateTimeDetails;
  shiftEndDetail: AccurateTimeDetails;
  isMoreThanOneAssignment: boolean;
  areShiftsValid: boolean;
  isShiftModified: boolean;
  loadIconsImmediately: boolean;
  isShiftSelected: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DeferredAssignmentShiftCardCellViewHelperService {
  private previewTemplate: TemplateRef<ShiftCardCellViewPreviewContext> | null =
    null;
  private previewTemplateContent: TemplateRef<
    Partial<ShiftCardCellViewPreviewContext>
  > | null = null;

  setPreviewTemplate(
    template: TemplateRef<ShiftCardCellViewPreviewContext>,
  ): void {
    this.previewTemplate = template;
  }

  getPreviewTemplate(): TemplateRef<ShiftCardCellViewPreviewContext> | null {
    return this.previewTemplate;
  }

  setPreviewTemplateContent(
    template: TemplateRef<Partial<ShiftCardCellViewPreviewContext>>,
  ): void {
    this.previewTemplateContent = template;
  }

  getPreviewTemplateContent(): TemplateRef<
    Partial<ShiftCardCellViewPreviewContext>
  > | null {
    return this.previewTemplateContent;
  }

  clearReferences() {
    this.previewTemplate = null;
    this.previewTemplateContent = null;
  }
}
